<template>
    <div class="row">
        <div class="col-12 col-md-6 mb-2">
            <label class="akkurate-dark small" for="first_name">Group Name <star></star></label>
            <b-form-group id="first_name" label-for="first_name">
                <b-form-input class="mt-1 field-container fields" type="text" placeholder="Enter Group Name"
                    v-model="form.first_name"></b-form-input>
                <errors v-if="form.errors.first_name">
                    {{ form.errors.first_name[0] }}
                </errors>
            </b-form-group>
        </div>

        <div class="col-12 col-md-6 mb-2">
            <label class="akkurate-dark small" for="email">Group Email</label>
            <b-form-group id="email" label-for="email">
                <b-form-input class="mt-1 field-container fields" type="email"
                    placeholder="Enter Group Email Address" v-model="form.email"></b-form-input>
                <errors v-if="form.errors.email">
                    {{ form.errors.email[0] }}
                </errors>
            </b-form-group>
        </div>

        <div class="col-12 col-md-6 mb-2">
            <label class="akkurate-dark small" for="phone">Phone Number<star></star></label>
            <b-form-group id="phone" label-for="phone">
                <b-form-input class="mt-1 field-container fields" type="number"
                    placeholder="Enter Phone Number Eg. 0244411100" v-model="form.mobile"></b-form-input>
                <errors v-if="form.errors.mobile">
                    {{ form.errors.mobile[0] }}
                </errors>
            </b-form-group>
        </div>


        <div class="col-12 col-md-6 mb-2">
            <label class="akkurate-dark small" for="mobile_secondary">Secondary Phone Number</label>
            <b-form-group id="mobile_secondary" label-for="mobile_secondary">
                <b-form-input class="mt-1 field-container fields" type="number"
                    placeholder="Enter Phone Number Eg. 0244411100" v-model="form.mobile_secondary"></b-form-input>
                <errors v-if="form.errors.mobile_secondary">
                    {{ form.errors.mobile_secondary[0] }}
                </errors>
            </b-form-group>
        </div>

        <div class="col-12 col-md-6 mb-2">
            <label class="akkurate-dark small" for="mandate">Mandate</label>
            <b-form-group id="mandate" label-for="mandate">
                <multiselect class="mt-1 field-container" v-model="form.mandate" selectLabel="" deselectLabel=""
                    :options="mandates"></multiselect>
                <errors v-if="form.errors.mandate">
                    {{ form.errors.mandate[0] }}
                </errors>
            </b-form-group>
        </div>

        <div class="col-md-6 mb-2">
            <div class="form-group">
                <label class="akkurate-dark small" for="fund_source">Fund Source <star></star></label>
                <b-form-group id="fund_source" label-for="fund_source" class="akkurate-dark">
                    <b-form-input v-model="form.fund_source" id="fund_source" class="mt-1 field-container fields"
                        type="text" placeholder="Enter Fund Source">
                    </b-form-input>
                </b-form-group>
                <!-- <label>Fund Source</label>
                                      <input type="text" class="mb-3 mt-2 field-container fields" v-model="form.fund_source"> -->
                <errors v-if="form.errors.fund_source">
                    {{ form.errors.fund_source[0] }}
                </errors>
            </div>
        </div>

    </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
export default {
    name: "PersonalDetails",
    props: ['form', 'roles', 'add_or_edit'],
    components: {
        Multiselect
    },
    data() {
        return {
            mandates: ["ONLY_PRINCIPAL_SIGNATORY", "PRINCIPAL_SIGNATORY_AND_ANY_OTHER_ONE",
                "ANY_OTHER_TWO_OF_THE_SIGNATORIES"],
        }
    },

    methods: {

    }
}
</script>